<template>
  <v-container fluid class="ma-4 px-8">
    <v-row justify="start" align="center">
      <v-col cols="12" md="3" class="py-0 my-0">
        <v-select
          v-model="form.payment_type"
          :items="['Admission', 'Academic']"
          outlined
          dense
          hide-details="auto"
          label="Payment"
          @change="reportData = []"
        ></v-select>
      </v-col>
      <v-col cols="12" md="3" class="py-0 my-0">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="displayDate"
              readonly
              outlined
              label="Date Range"
              dense
              v-bind="attrs"
              v-on="on"
              hide-details="auto"
            ></v-text-field>
          </template>
          <v-sheet
            class="pa-4"
            elevation="4"
            style="background-color: white; border-radius: 8px"
          >
            <v-row no-gutters>
              <v-col>
                <v-date-picker
                  v-model="selectedDates"
                  range
                  @input="onDateChange"
                ></v-date-picker>
              </v-col>

              <v-col class="pl-4 pt-4" style="max-width: 150px">
                <div
                  v-for="option in dateOptions"
                  :key="option.label"
                  class="mb-2 pt-2"
                >
                  <v-btn small color="accent" @click="setQuickDate(option)">
                    {{ option.label }}
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-sheet>
        </v-menu>
      </v-col>
      <v-col cols="12" md="3" class="py-0 my-0" v-if="showPartner()">
        <v-autocomplete
          v-model="form.partner_id"
          :items="partners"
          item-text="name"
          item-value="id"
          outlined
          dense
          hide-details="auto"
          label="Partner"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4">
        <v-btn
          :loading="loading"
          class="accent white--text mr-2"
          @click="search"
        >
          Search
        </v-btn>
        <v-btn
          :disabled="!reportData.length"
          class="accent white--text ml-2"
          @click="download"
        >
          <v-icon>mdi-download</v-icon> Download
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="bulkPaymentReportHeaders"
            :items="reportData"
            fixed-header
          >
            <template v-slot:no-data>
              <div class="text-center">No data available</div>
            </template>
            <template v-slot:[`item.partner_id`]="{ item }">
              {{ getPartnerName(item.partner_id) }}
            </template>
            <template v-slot:[`item.view_students`]="{ item }">
              <v-icon class="mr-2" color="accent" @click="navigate(item)">
                mdi-dots-horizontal
              </v-icon>
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { bulkPaymentReportHeaders } from "@/constants/headers";

export default {
  components: {},
  data() {
    return {
      menu: false,
      selectedDates: [],
      displayDate: "",
      form: {
        from_date: null,
        to_date: null,
        partner_id: null,
        payment_type: "Admission",
      },
      dateOptions: [
        { label: "Today", days: 0 },
        { label: "Yesterday", type: "yesterday" },
        { label: "This Week", type: "week" },
        { label: "Last 7 Days", days: 6 },
        { label: "This Month", type: "month" },
        { label: "Last 30 Days", days: 29 },
        { label: "Reset", type: "reset" },
      ],
      reportData: [],
      bulkPaymentReportHeaders,
      partners: [],
      loading: false,
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    formatDate() {
      return (date) => {
        let newDate = new Date(date);

        const day = String(newDate.getDate()).padStart(2, "0");
        const month = String(newDate.getMonth() + 1).padStart(2, "0");
        const year = newDate.getFullYear();
        return `${day}-${month}-${year}`;
      };
    },
    formatDateBackend() {
      return (date) => {
        let newDate = new Date(date);

        const day = String(newDate.getDate()).padStart(2, "0");
        const month = String(newDate.getMonth() + 1).padStart(2, "0");
        const year = newDate.getFullYear();
        return `${year}-${month}-${day}`;
      };
    },
  },
  watch: {
    form: {
      deep: true,
      handler(v) {
        this.$store.commit("setPageFilters", v);
      },
    },
  },
  async created() {
    if (
      this.currentUser.partner_payment_required ||
      this.currentUser.partner_id == 1
    ) {
      this.$store.commit("setBreadcrumbs", [{ text: "Bulk Payments" }]);
      if (this.$store.state.pageFilters) {
        this.form = { ...this.$store.state.pageFilters };
        if (this.form.from_date && this.form.to_date) {
          this.selectedDates = [this.form.from_date, this.form.to_date];
          this.onDateChange();
        }
      }
      await this.showPartnerFilter();
      this.search();
    } else {
      this.$router.push("/");
    }
  },
  methods: {
    async search() {
      this.loading = true;
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      await this.$axios
        .get(`/business_partner_bulk_payments?${queryString}`)
        .then((res) => {
          this.reportData = res.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    objectToQueryParams(obj) {
      return Object.keys(obj)
        .filter(
          (key) =>
            obj[key] !== undefined && obj[key] !== null && obj[key] !== ""
        )
        .map(
          (key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key])
        )
        .join("&");
    },
    formatDisplayDate(from, to) {
      return `${this.formatDate(from)}~${this.formatDate(to)}`;
    },
    onDateChange() {
      if (this.selectedDates.length === 2) {
        const [fromDate, toDate] = this.selectedDates;
        this.form.from_date = this.formatDateBackend(fromDate);
        this.form.to_date = this.formatDateBackend(toDate);
        this.displayDate = this.formatDisplayDate(fromDate, toDate);
      }
    },
    setQuickDate(option) {
      if (option.type === "reset") {
        this.form.from_date = null;
        this.form.to_date = null;
        this.displayDate = "";
        this.selectedDates = [];
        return;
      }
      const today = new Date();
      let fromDate = new Date(today);
      let toDate = new Date(today);
      if (option.type === "week") {
        fromDate.setDate(today.getDate() - today.getDay());
      } else if (option.type === "month") {
        fromDate.setDate(1);
      } else if (option.type === "yesterday") {
        fromDate.setDate(today.getDate() - 1);
        toDate.setDate(today.getDate() - 1);
      } else if (option.days) {
        fromDate.setDate(today.getDate() - option.days);
      }
      this.selectedDates = [
        this.formatDateBackend(fromDate),
        this.formatDateBackend(toDate),
      ];
      this.onDateChange();
    },
    showPartner() {
      return (
        this.currentUser.partner_id == 1 ||
        (this.partners.length > 1 && this.currentUser.partner_level != "S")
      );
    },
    async showPartnerFilter() {
      await this.getPartners();
      if (
        this.currentUser.role === "Business" &&
        this.currentUser.partner_level === "P"
      ) {
        this.partners = this.partners.filter(
          (item) =>
            item.id === this.currentUser.partner_id ||
            item.parent_id === this.currentUser.partner_id
        );
      }
    },
    async getPartners() {
      try {
        const response = await this.$axios.get(
          "/partners?adm_applicant_fee_collect=true"
        );
        this.partners = response.data.data;
        if (this.currentUser.partner_id != 1) {
          this.form.partner_id = this.currentUser.partner_id;
        } else {
          this.form.partner_id = response.data.data[0].id;
        }
      } catch (error) {
        console.log(error);
      }
    },
    getPartnerName(id) {
      const partner = this.partners.find((partner) => partner.id === id);
      return partner ? partner.name : "";
    },
    navigate(item) {
      this.$router.push({
        path: `bulk_payment_students`,
        query: {
          id: `${item.id}`,
          payment_type: `${item.payment_type}`,
        },
      });
    },
    async download() {
      const queryString = this.objectToQueryParams(this.form);
      this.$axios
        .get(`/download_bulk_payments_report?${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Bulk Payments.csv`);
          document.body.appendChild(link);
          link.click();
        });
    },
  },
};
</script>

<style scoped></style>
